import Modal from "components/layout/modal";
import { parse } from "lib/locale";
import { ListEntity } from "models/list-entity";
import { FunctionComponent } from "react";
import { useLocale } from "stores/hooks/locale";
import ListEntityFieldsTable from "./fields-table";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import Form from "components/forms/form";
import { CancelButton } from "components/forms/buttons.utils";
import { useForm } from "react-hook-form";
import { List } from "models/list";

interface EntityFieldsModalProps {
  list: List;
  entity: ListEntity;
  onChange: () => Promise<void>;
  onClose: () => Promise<void>;
}

const EntityFieldsModal: FunctionComponent<EntityFieldsModalProps> = ({
  list,
  entity,
  onChange,
  onClose,
}) => {
  const locale = useLocale();

  const handleClose = async () => {
    onChange();
    onClose();
  };

  const methods = useForm();

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: handleClose, text: "Sulje" },
  ];

  const title = parse(entity.name, locale);
  return (
    <Modal title={title} wide>
      <ListEntityFieldsTable list={list} entityUuid={entity.uuid} />
      <Form methods={methods} onSubmit={handleClose}>
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default EntityFieldsModal;
